'use client';

import { LoadingSpinner } from '../loading-spinner';
import { Icon, IconType } from '../icons';
import { cn, TSmallLinkProps } from 'types';

export const SmartLink = (props: Partial<TSmallLinkProps>) => {
  const {
    className = '',
    iconClassName,
    iconColor = 'var(--color-black)',
    iconSize = 24,
    iconLeft,
    iconRight,
    isLoading = false,
    path,
    children,
    onLinkClick,
    small = false,
    customClasses = '',
    isDisabled = false,
  } = props;

  const RenderIcon = ({ iconParam }: { iconParam: IconType }) => (
    <Icon icon={iconParam} fill={iconColor} height={iconSize} width={iconSize} className={iconClassName} />
  );
  return (
    <div
      className={cn('flex items-center gap-2', className, {
        'opacity-50 pointer-events-none cursor-not-allowed': isDisabled,
        'cursor-pointer': !isDisabled,
      })}
      onClick={onLinkClick}
    >
      {/* Icon Left */}
      {iconLeft && <RenderIcon iconParam={iconLeft} />}

      {/* Loading Spinner or Link */}
      {isLoading ? (
        <LoadingSpinner color={'var(--color-black)'} size={32} />
      ) : (
        <a
          href={path}
          className={cn('no-underline hover:opacity-80 hover:no-underline border-solid leading-[100%]', {
            'text-lg font-extrabold border-b-2': !small,
            'text-sm font-semibold border-b': small,
            [customClasses]: customClasses,
          })}
        >
          {children}
        </a>
      )}
      {/* Icon Right */}
      {iconRight && <RenderIcon iconParam={iconRight} />}
    </div>
  );
};
